/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Quarterlydata_Title2Inputs */

const en_coinvestments_report_quarterlydata_title2 = /** @type {(inputs: Coinvestments_Report_Quarterlydata_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter quarterly data`)
};

/**
* | output |
* | --- |
* | "Enter quarterly data" |
*
* @param {Coinvestments_Report_Quarterlydata_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_quarterlydata_title2 = /** @type {((inputs?: Coinvestments_Report_Quarterlydata_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Quarterlydata_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_quarterlydata_title2(inputs)
});
export { coinvestments_report_quarterlydata_title2 as "coInvestments_report_quarterlyData_title" }